import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  tags: {
    [BillingMode.Stripe]: 'Cargo desde método de pago',
    [BillingMode.InternalInvoicing]: 'Cargo desde ventas',
    active: 'Activa',
    on_trial: 'En prueba',
    launch_pending: 'En espera hasta la fecha de lanzamiento',
    billing_disabled: 'Facturación desactivada',
    on_grace_period: 'En periodo de gracia',
    past_due: 'Vencida',
    cancelled: 'Cancelada',
  },
};
